import { useContext } from 'react';

import { BFFContext } from '../context';
// eslint-disable-next-line import/order
import type { BFFConsumerEnum } from '../../constants';

export function useConsumer(): {
    consumer: BFFConsumerEnum | null;
} {
	const {
		value: { consumer },
	} = useContext(BFFContext);

	return {
		consumer,
	};
}
